import React, { useState, useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

import { gsap } from 'gsap'
import classnames from 'classnames/bind'
import { Text, RichText } from 'components/typo'
import Icon from './Icon'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const Question = ({ question, answer, openByDefault }) => {
  const [open, setOpen] = useState(openByDefault)
  const accordion = useRef()

  useIsomorphicLayoutEffect(() => {
    if (open) {
      gsap.set(accordion.current, { height: 'auto' })
      gsap.from(accordion.current, {
        duration: 0.7,
        height: 0,
        ease: 'elastic.out(0.3, 0.3)',
        immediateRender: false,
      })
    } else {
      gsap.to(accordion.current, {
        duration: 0.2,
        height: 0,
        ease: 'power3.easeOut',
        immediateRender: false,
      })
    }
  }, [open])

  return (
    <div className={cx(css.Question, { open })}>
      <div className={css.title} onClick={() => setOpen(!open)}>
        <Text className={css.text} size="small" theme="dark" tag="span">
          {question}
        </Text>
        <Icon isOpen={open} />
      </div>
      <div className={css.accordion} ref={accordion}>
        <div className={css.answer}>
          <RichText className={css.content} text={answer} />
        </div>
      </div>
    </div>
  )
}

export default Question
